<template>
  <div>
    <b-row>
      <b-col cols="4" v-if='file'>
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }} التي تمّ خلالها الموافقة على الانضمام / الانتساب
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:file } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
      </b-col> 
      
      <b-col md="4" cols="12" v-else>
        <info-card
        label="رقم محضر الجلسة الإدارية التي تمّ خلالها الموافقة على الانضمام / الانتساب"
        :value="data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label :''"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="اسم المنظمة الدولية"
          :value="data.name"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="الدولة"
          :value="data.country_id ? data.country_id.name : ''"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="عنوان مقر المنظمة الدولية"
          :value="data.address"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="مجال عمل المنظمة الدولية"
          :value="data.field_of_work"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="أهداف المنظمة الدولية"
          :value="data.international_organization_goals"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="كافة البيانات المتوفرة لدى المنظمة غير حكومية حول المنظمة لدولية"
          :value="data.international_organization_data"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-2">
        <h5>
          المُرفقات :
        </h5>
      </b-col>
      <b-col cols="4">
        
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              صورة عن الدعوة الموجهة للمنظمة الغير حكومية من قبل المنظمة الدولية للانضمام 
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.invitation_doc } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              صك إحداث المنظمة الدولية 
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.charter_doc } }"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
      
      <b-col cols="4">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              النظام الداخلي للمنظة الدولية 
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.internal_system_doc } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>

      <b-col cols="4">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              كتاب مُقدم من المنظمة الدولية يوضح فيه أعضاء إدارتها و أنشطتها و أماكن انتشارها و مصادر تمويلها وأعضاء المنظمة 
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.activities_and_funding_doc } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>

      <b-col cols="4">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              صور جوازات سفر أعضاء إدارة المنظمة الدولية 
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.passports_doc } }"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>

<b-col cols="4">
  <div class="info-card px-2 py-1 my-1">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        آخر تقرير سنوي
      </div>
      <div>
        <b-button

            variant="flat-info"
            v-b-toggle.doc-view
            class="btn-icon mx-25"
            v-b-tooltip.hover.v-info.bottom
            title="عرض المستند المرفوع"
            :to="{ name: 'file-view', query: { ep:data.latest_annual_report_doc } }"
        >
          <feather-icon icon="EyeIcon"/>
        </b-button>
      </div>
    </div>
    <div>
      <hr />
    </div>
  </div>
</b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import axios from "@axios";
import router from "@/router";

export default {
  components: {
    BCard, BImg , BCol , InfoCard , BRow , BButton
  },
  data() {
      return {
          file: '',
      }
  },
  props: {
    data : Object ,
  },

  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
  watch: {
    data: {
        handler: async function(newVal, oldVal) {
            
            const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                console.log("currentRoute" , currentRoute)
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }
        },
      deep: true
      }
  },
};
</script>